/// <amd-module name="Repos/Tfvc/Views/FilesHubActions/RestClient/Tfvc" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\tfvc\views\files-hub-actions\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Tfvc from "Repos/Common/Contracts/Git";

export interface ITfvcRestClient extends IVssRestClient {
    /**
     * Create a new changeset.
     * 
     * @param changeset - 
     * @param project - Project ID or project name
     */
    createChangeset(changeset: Tfvc.TfvcChangeset, project?: string): Promise<Tfvc.TfvcChangesetRef>;
}

class TfvcRestClient extends RestClientBase implements ITfvcRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a new changeset.
     * 
     * @param changeset - 
     * @param project - Project ID or project name
     */
    public async createChangeset(
        changeset: Tfvc.TfvcChangeset,
        project?: string
        ): Promise<Tfvc.TfvcChangesetRef> {

        return this.beginRequest<Tfvc.TfvcChangesetRef>({
            apiVersion: "5.0-preview.3",
            method: "POST",
            routeTemplate: "{project}/_apis/tfvc/changesets/{id}",
            routeValues: {
                project: project
            },
            body: changeset
        });
    }

}

export const TfvcClientName = "Repos.FilesHubActions.Tfvc.ITfvcRestClient";

export function getTfvcClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITfvcRestClient {
    return pageContext.getRestClient<ITfvcRestClient>(TfvcClientName, options);
}

RestClients.add(TfvcClientName, { 
    factory: TfvcRestClient,
    options: {
        resourceAreaId: "8aa40520-446d-40e6-89f6-9c9f9ce44c48",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
